import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-sched-layout",
  templateUrl: "./sched-layout.component.html",
})
export class SchedLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
